import { render, staticRenderFns } from "./avatar-cutter.vue?vue&type=template&id=5e80a688&scoped=true&"
import script from "./avatar-cutter.vue?vue&type=script&lang=js&"
export * from "./avatar-cutter.vue?vue&type=script&lang=js&"
import style0 from "./avatar-cutter.vue?vue&type=style&index=0&id=5e80a688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e80a688",
  null
  
)

export default component.exports